import { render } from "./CategoryView.vue?vue&type=template&id=34caa63e&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=34caa63e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34caa63e"]])

export default __exports__